import React from "react"

interface AssetMap {
  phoneInHand: string
  close: string
}

interface CommunityGuidelinesAgreementProps {
  assets: AssetMap
  onAgree: () => void
}

export default function CommunityGuidelinesAgreement({ assets, onAgree }: CommunityGuidelinesAgreementProps) {
  const [modalVisible, setModalVisible] = React.useState(false)

  return (
    <>
      {modalVisible && <CommunityGuidelinesModal assets={assets} dismiss={() => setModalVisible(false)} />}
      <div className="app-screen-container new-feed-post community-guidelines">
        <div className="screen-heading">
          <img src={assets.phoneInHand} alt="Phone in hand" />
          <h1>Community Guidelines</h1>
        </div>

        <div className="screen-body">
          <p>We have a few rules that we ask all Spark golfers to abide by when posting:</p>

          <ul>
            <li>No cheating accusations</li>
            <li>No pace of play complaints</li>
            <li>No spam or self-promotion</li>
            <li>No inappropriate content</li>
            <li>Be respectful of others</li>
            <li>Keep it positive</li>
          </ul>

          <p>Any posts or comments that violate these guidelines will be taken down.</p>

          <button className="action-button block" onClick={onAgree}>
            I Agree
          </button>
          <div className="secondary-link">
            <a onClick={() => setModalVisible(true)}>View Full Community Guidelines</a>
          </div>
        </div>
      </div>
    </>
  )
}

interface CommunityGuidelinesModalProps {
  assets: AssetMap
  dismiss: () => void
}

function CommunityGuidelinesModal({ assets, dismiss }: CommunityGuidelinesModalProps) {
  React.useEffect(() => {
    const content = document.getElementById("community-guidelines-modal-content")
    const container = document.getElementById("community-guidelines-modal-container")
    if (content && container) {
      container.innerHTML = content.innerHTML
    }
  }, [])

  return (
    <div id="community-guidelines-modal" className="modal modal--bottom-sheet-mobile show">
      <div className="modal-wrapper">
        <div className="modal-header">
          <div className="modal-header-inner">
            <div className="modal-title">Community Guidelines</div>
            <a onClick={dismiss} className="modal-dismiss">
              <img src={assets.close} alt="Close" />
            </a>
          </div>
        </div>
        <div className="modal-main">
          <div id="community-guidelines-modal-container" className="container"></div>
        </div>
      </div>
      <div className="modal-mask" onClick={dismiss} />
    </div>
  )
}
